import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-burger-test-id": "",
    class: _normalizeClass(["burger", { open: _ctx.isOpen, landing: _ctx.landing }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [...(_cache[1] || (_cache[1] = [
    _createElementVNode("span", null, null, -1),
    _createElementVNode("span", null, null, -1),
    _createElementVNode("span", null, null, -1)
  ]))], 2))
}